// Used to combine data on a quest (like authors) with org users with whatever role
// Needed for populating select options when a quest author is deleted, no longer has that role (for example)
export function combineQuestUsersWithRoleUsers(questUsers, users) {
  let combinedUsers = users.concat(questUsers)
  const idPositions = combinedUsers.map(user => user.id)

  return combinedUsers.filter((item, pos) => {
    return idPositions.indexOf(item.id) === pos
  })
}



// WEBPACK FOOTER //
// ./src/utils/users.js